<h2 mat-dialog-title>{{ "HTL.SHORTITEM.updateNextDueMaintenance" | translate }} / {{ registrationMark }} {{ getHookHoistLabel() }}</h2>
<div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-left: 26px; margin-top: -20px">
    @switch (inspectionType) {
        @case ("hook") {
            <div style="margin-right: 10px; font-size: medium">Hook Current Total Hours: {{ helicopterHooks[0]?.hours }}</div>
            <div style="margin-right: 10px; font-size: medium">Hook Current Total Cycles: {{ helicopterHooks[0]?.cycles }}</div>
        }
        @case ("hoist") {
            <div style="margin-right: 10px; font-size: medium">Hoist Current Total Hours: {{ helicopterHoists[0]?.hours }}</div>
            <div style="margin-right: 10px; font-size: medium">Hoist Current Total Cycles: {{ helicopterHoists[0]?.cycles }}</div>
        }
        @default {
            <div style="margin-right: 10px; font-size: medium">Aircraft Current Total Hours: {{ totalHours || 0 }}</div>
            @if (showFlightNumber) {
                <div style="margin-right: 10px; font-size: medium">Last Flight Number: {{ helicopterData?.flightNumber || 0 }}</div>
            }
            <div style="font-size: medium">Aircraft Current Total Cycles: {{ totalCycles || 0 }}</div>
        }
    }
</div>
<mat-dialog-content class="mat-typography" style="padding-top: 20px">
    <form #nextDueMaintenanceForm="ngForm" fxFlex="100" (ngSubmit)="onFormSubmit()" [formGroup]="nextDueMaintenanceFormGroup">
        @if (inspectionType !== "hook" && inspectionType !== "hoist") {
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: -16px; margin-bottom: 10px">
                <mat-checkbox label="Maintain Original Schedule" name="mode" formControlName="mode" (change)="onModeChange($event)"></mat-checkbox>
                <span style="margin-top: 8px">Maintain Original Schedule</span>
                <mat-icon style="margin-left: 4px; margin-top: 8px; color: #4050b5" (click)="infoButtonClicked()">info</mat-icon>
            </div>
        }
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            @if (hookHoist) {
                @if (hasHooks && hasHoist) {
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-select name="accessoryType" formControlName="accessoryType" [placeholder]="'HTL.SHORTITEM.accessoryType' | translate">
                            <mat-option [value]="0"> {{ "HTL.SHORTITEM.hook" | translate }} </mat-option>
                            <mat-option [value]="1"> {{ "HTL.SHORTITEM.hoist" | translate }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                } @else {
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "HTL.SHORTITEM.accessoryType" | translate }}</mat-label>
                        <input matInput name="accessoryType" formControlName="accessoryType" />
                    </mat-form-field>
                }
            }
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-select name="type" formControlName="type" [placeholder]="'HTL.SHORTITEM.taskType' | translate">
                    <mat-option [value]="0"> {{ "HTL.SHORTITEM.singleTask" | translate }} </mat-option>
                    <mat-option [value]="1"> {{ "HTL.SHORTITEM.recurring" | translate }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="{{ hookHoist ? '25' : '50' }}" appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.SHORTITEM.description" | translate }}</mat-label>
                <input
                    type="text"
                    [placeholder]="'HTL.SHORTITEM.description' | translate"
                    aria-label="Number"
                    matInput
                    formControlName="inspectionTypeName"
                    [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete" (closed)="onAutocompleteClosed()">
                    @for (option of inspectionTypeOptions; track option) {
                        <mat-option [value]="option.name">
                            {{ option.name }}
                        </mat-option>
                    }
                </mat-autocomplete>
                @if (nextDueMaintenanceFormGroup.controls["inspectionTypeName"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex="25" appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.SHORTITEM.status" | translate }}</mat-label>
                <mat-select name="status" formControlName="status" [placeholder]="'HTL.SHORTITEM.status' | translate">
                    <mat-option [value]="1"> {{ "HTL.SHORTITEM.active" | translate }} </mat-option>
                    <mat-option [value]="2"> {{ "HTL.SHORTITEM.stopped" | translate }} </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div style="margin: 10px; margin-top: -5px">
            {{ "HTL.SHORTITEM.interval" | translate }}
        </div>
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.SHORTITEM.days" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.SHORTITEM.intervalDays' | translate" name="intervalDays" formControlName="intervalDays" type="number" min="1" />
                @if (nextDueMaintenanceFormGroup.controls["intervalDays"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
                @if (nextDueMaintenanceFormGroup.controls["intervalDays"].hasError("min")) {
                    <mat-error>{{ "HTL.SHORTITEM.minValueError" | translate }}</mat-error>
                }
            </mat-form-field>
            @if (!hookHoist || showHours) {
                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                    <mat-label>{{ "HTL.SHORTITEM.hours" | translate }}</mat-label>
                    <input matInput [placeholder]="'HTL.SHORTITEM.intervalHours' | translate" name="intervalHours" formControlName="intervalHours" />
                    <mat-hint>HH:MM</mat-hint>
                    @if (nextDueMaintenanceFormGroup.controls["intervalHours"].hasError("required")) {
                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                    }
                    @if (nextDueMaintenanceFormGroup.controls["intervalHours"].hasError("pattern")) {
                        <mat-error> {{ "HTL.SHORTITEM.hoursPatternError" | translate }}</mat-error>
                    }
                </mat-form-field>
            }
            @if (!hookHoist) {
                @if (showFlightNumber) {
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "HTL.SHORTITEM.flightNumber" | translate }}</mat-label>
                        <input
                            matInput
                            [placeholder]="'HTL.SHORTITEM.intervalFlightNumber' | translate"
                            name="intervalFlightNumber"
                            formControlName="intervalFlightNumber"
                            type="number"
                            min="1"
                        />
                        @if (nextDueMaintenanceFormGroup.controls["intervalFlightNumber"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                        @if (nextDueMaintenanceFormGroup.controls["intervalFlightNumber"].hasError("min")) {
                            <mat-error> {{ "HTL.SHORTITEM.minValueError" | translate }}</mat-error>
                        }
                    </mat-form-field>
                }
            }
            @if (!hookHoist || showCycles) {
                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                    <mat-label>{{ "HTL.SHORTITEM.cycles" | translate }}</mat-label>
                    <input matInput [placeholder]="'HTL.SHORTITEM.intervalCycles' | translate" name="intervalCycles" formControlName="intervalCycles" type="number" min="1" />
                    @if (nextDueMaintenanceFormGroup.controls["intervalCycles"].hasError("required")) {
                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                    }
                    @if (nextDueMaintenanceFormGroup.controls["intervalCycles"].hasError("min")) {
                        <mat-error> {{ "HTL.SHORTITEM.minValueError" | translate }}</mat-error>
                    }
                </mat-form-field>
            }
        </div>
        <div style="margin: 10px">
            {{ !isRecurring ? ("HTL.SHORTITEM.nextDue" | translate) : ("HTL.SHORTITEM.firstNextDue" | translate) }}
        </div>
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.SHORTITEM.date" | translate }}</mat-label>
                <input matInput [matDatepicker]="nextDueDatePicker" [placeholder]="'HTL.SHORTITEM.nextDueDate' | translate" name="nextDueDate" formControlName="nextDueDate" />
                <mat-datepicker-toggle matSuffix [for]="nextDueDatePicker"> </mat-datepicker-toggle>
                <mat-datepicker #nextDueDatePicker></mat-datepicker>
                @if (nextDueMaintenanceFormGroup.controls["nextDueDate"].hasError("matDatepickerParse")) {
                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                }
                @if (nextDueMaintenanceFormGroup.controls["nextDueDate"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            @if (!hookHoist || showHours) {
                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                    <mat-label>{{ "HTL.SHORTITEM.hours" | translate }}</mat-label>
                    <input matInput [placeholder]="'HTL.SHORTITEM.nextDueHours' | translate" name="nextDueHours" formControlName="nextDueHours" />
                    @if (nextDueMaintenanceFormGroup.controls["nextDueHours"].hasError("required")) {
                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                    }
                    @if (nextDueMaintenanceFormGroup.controls["nextDueHours"].hasError("pattern")) {
                        <mat-error> {{ "HTL.SHORTITEM.hoursPatternError" | translate }}</mat-error>
                    }
                    <mat-hint>HH:MM</mat-hint>
                </mat-form-field>
            }
            @if (!hookHoist) {
                @if (showFlightNumber) {
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "HTL.SHORTITEM.flightNumber" | translate }}</mat-label>
                        <input
                            matInput
                            [placeholder]="'HTL.SHORTITEM.nextDueFlightNumber' | translate"
                            name="nextDueFlightNumber"
                            formControlName="nextDueFlightNumber"
                            type="number"
                            min="1"
                        />
                        @if (nextDueMaintenanceFormGroup.controls["nextDueFlightNumber"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                        @if (nextDueMaintenanceFormGroup.controls["nextDueFlightNumber"].hasError("min")) {
                            <mat-error> {{ "HTL.SHORTITEM.minValueError" | translate }}</mat-error>
                        }
                    </mat-form-field>
                }
            }
            @if (!hookHoist || showCycles) {
                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                    <mat-label>{{ "HTL.SHORTITEM.cycles" | translate }}</mat-label>
                    <input matInput [placeholder]="'HTL.SHORTITEM.nextDueCycles' | translate" name="nextDueCycles" formControlName="nextDueCycles" type="number" min="1" />
                    @if (nextDueMaintenanceFormGroup.controls["nextDueCycles"].hasError("required")) {
                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                    }
                    @if (nextDueMaintenanceFormGroup.controls["nextDueCycles"].hasError("min")) {
                        <mat-error> {{ "HTL.SHORTITEM.minValueError" | translate }}</mat-error>
                    }
                </mat-form-field>
            }
        </div>
        @if (showTolerance) {
            <div style="margin: 10px">
                {{ "HTL.SHORTITEM.tolerance" | translate }}
            </div>
        }
        @if (showTolerance) {
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="5px">
                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                    <mat-label>{{ "HTL.SHORTITEM.days" | translate }}</mat-label>
                    <input matInput [placeholder]="'HTL.SHORTITEM.toleranceDays' | translate" name="toleranceDays" formControlName="toleranceDays" type="number" min="0" />
                    @if (nextDueMaintenanceFormGroup.controls["toleranceDays"].hasError("min")) {
                        <mat-error>
                            {{ "HTL.SHORTITEM.minValueError" | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                @if (!hookHoist || showHours) {
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "HTL.SHORTITEM.hours" | translate }}</mat-label>
                        <input matInput [placeholder]="'HTL.SHORTITEM.toleranceHours' | translate" name="toleranceHours" formControlName="toleranceHours" />
                        @if (nextDueMaintenanceFormGroup.controls["toleranceHours"].hasError("pattern")) {
                            <mat-error>
                                {{ "HTL.SHORTITEM.hoursPatternError" | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (!hookHoist) {
                    @if (showFlightNumber) {
                        <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                            <mat-label>{{ "HTL.SHORTITEM.flightNumber" | translate }}</mat-label>
                            <input
                                matInput
                                [placeholder]="'HTL.SHORTITEM.toleranceFlightNumber' | translate"
                                name="toleranceFlightNumber"
                                formControlName="toleranceFlightNumber"
                                type="number"
                                min="0"
                            />
                            @if (nextDueMaintenanceFormGroup.controls["toleranceFlightNumber"].hasError("min")) {
                                <mat-error>
                                    {{ "HTL.SHORTITEM.minValueError" | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    }
                }
                @if (!hookHoist || showCycles) {
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "HTL.SHORTITEM.cycles" | translate }}</mat-label>
                        <input
                            matInput
                            [placeholder]="'HTL.SHORTITEM.toleranceCycles' | translate"
                            name="toleranceCycles"
                            formControlName="toleranceCycles"
                            type="number"
                            min="0"
                        />
                        @if (nextDueMaintenanceFormGroup.controls["toleranceCycles"].hasError("min")) {
                            <mat-error>
                                {{ "HTL.SHORTITEM.minValueError" | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                }
            </div>
        }
        @if (!hookHoist) {
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="5px">
                @if (showReference) {
                    <mat-form-field fxFlex="30" appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "HTL.SHORTITEM.reference" | translate }}</mat-label>
                        <input type="text" [placeholder]="'HTL.SHORTITEM.description' | translate" aria-label="Number" matInput formControlName="reference" />
                    </mat-form-field>
                }
                @if (showEnginePowerCheck) {
                    <mat-checkbox formControlName="isEnginePowerCheck" labelPosition="before" style="padding-top: 5px; padding-left: 20px">{{
                        "HTL.SHORTITEM.enginePowerCheck" | translate
                    }}</mat-checkbox>
                }
            </div>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (nextDueMaintenanceFormGroup.hasError("noInterval")) {
        <mat-error class="mr-10"> {{ "HTL.SHORTITEM.noIntervalError" | translate }}</mat-error>
    }
    @if (nextDueMaintenanceFormGroup.hasError("missingNextDue")) {
        <mat-error class="mr-10"> {{ "HTL.SHORTITEM.missingNextDue" | translate }}</mat-error>
    }
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="nextDueMaintenanceForm.ngSubmit.emit()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>

<ng-template #infoDialogTemplate>
    <mat-dialog-content class="mat-typography">
        <h2>Schedule Retention Behavior</h2>
        <div>This setting locks the original inspection schedule, regardless of when maintenance is actually performed.</div>
        <ul class="tree-list">
            <li>
                <span class="node-content"
                    ><span style="font-weight: bold">Days: </span>Next due dates are locked strictly to the original interval (e.g., every 30 days). Early or late inspections will
                    not shift the baseline.</span
                >
            </li>
            <li>
                <span class="node-content" style="font-weight: bold">Hours / Cycles:</span>
                <ul>
                    <li>
                        <span class="node-content"><span style="font-weight: bold">Early Inspection: </span> Remaining hours/cycles on the current interval are forfeited.</span>
                    </li>
                    <li>
                        <span class="node-content"><span style="font-weight: bold">Late Inspection: </span> The next deadline remains anchored to the original schedule.</span>
                    </li>
                </ul>
            </li>
        </ul>
        <strong>Example (10h Interval):</strong> If the first inspection is overdue and done at <strong>12h</strong>, the next deadline remains strictly at
        <strong>20h</strong> (not 22h).
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" mat-dialog-close>
            {{ "GENERAL.close" | translate }}
        </button>
    </mat-dialog-actions>
</ng-template>
